import { render, staticRenderFns } from "./HolidaySettingsEditForm.vue?vue&type=template&id=e4615aa0&scoped=true&"
import script from "./HolidaySettingsEditForm.vue?vue&type=script&lang=js&"
export * from "./HolidaySettingsEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4615aa0",
  null
  
)

export default component.exports